import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { getTotalIncomeByMonthAndYearForDashboardFailure, getTotalIncomeByMonthAndYearForDashboardSuccess } from '../../actions/InfluencerCampaignActions/getTotalIncomeByMonthAndYearForDashboardActions';

function* getTotalIncomeByMonthAndYearForDashboard({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.getTotalIncomeByMonthAndYearForDashboard,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_TOTAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_SUCCESS status :", response.data.status);
        console.log("GET_TOTAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_SUCCESS data :", response.data.response);
        console.log("GET_TOTAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getTotalIncomeByMonthAndYearForDashboardSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("GET_TOTAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_FAILURE status :", error?.response?.status);
        console.log("GET_TOTAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_FAILURE data:", error?.response?.data);
        console.log("GET_TOTAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_FAILURE error :", error);
        console.log('====================================');
        yield put(getTotalIncomeByMonthAndYearForDashboardFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getTotalIncomeByMonthAndYearForDashboardSaga() {
    yield takeLatest(actionTypes.GET_TOTAL_INCOME_MISSED_BY_MONTH_AND_YEAR_FOR_DASHBOARD_REQUEST, getTotalIncomeByMonthAndYearForDashboard);
}

export default getTotalIncomeByMonthAndYearForDashboardSaga;
